/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction } from 'react'

type ContextState = {
  ticketToSearch?: string | undefined
  setTicketToSearch: Dispatch<SetStateAction<string | undefined>>
  maxDaysRange: number
  unreadNotifications: number
  setUnreadNotifications: Dispatch<SetStateAction<number>>
  menuDisplayed: boolean
  handleDisplayMenu: (value?: boolean) => void
  filtersDisplayed: boolean
  handleDisplayFilters: () => void
}

interface GeneralProviderProps {
  children: React.ReactNode
}

const initialState = {
  ticketToSearch: undefined,
  setTicketToSearch: () => {},
  maxDaysRange: 14,
  unreadNotifications: 0,
  setUnreadNotifications: () => {},
  isLoadingAllCarriers: false,
  menuDisplayed: false,
  handleDisplayMenu: () => {},
  filtersDisplayed: false,
  handleDisplayFilters: () => {},
}

const GeneralContext = React.createContext<ContextState>(initialState)

export function GeneralProvider({ children }: GeneralProviderProps) {
  const [ticketToSearch, setTicketToSearch] = useState<string | undefined>(undefined)
  const [unreadNotifications, setUnreadNotifications] = useState<number>(0)
  const { maxDaysRange } = initialState
  const [menuDisplayed, setMenuDisplayed] = useState(false)
  const [filtersDisplayed, setFiltersDisplayed] = useState(false)

  const handleDisplayMenu = (value?: boolean) => {
    if (filtersDisplayed) {
      setFiltersDisplayed(false)
    }
    setMenuDisplayed(state => value ?? !state)
  }

  const handleDisplayFilters = () => {
    if (menuDisplayed) {
      setMenuDisplayed(false)
    }
    setFiltersDisplayed(!filtersDisplayed)
  }

  return (
    <GeneralContext.Provider
      value={{
        ticketToSearch,
        setTicketToSearch,
        maxDaysRange,
        unreadNotifications,
        setUnreadNotifications,
        menuDisplayed,
        handleDisplayMenu,
        filtersDisplayed,
        handleDisplayFilters,
      }}
    >
      {children}
    </GeneralContext.Provider>
  )
}

export function useGeneral(): ContextState {
  const context = useContext(GeneralContext)

  if (!context) throw Error('This hook can only be used under the FiltersProvider component')
  return context
}
